import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "6ac95cd4-7fb0-4a23-8f1c-ef6761144397",
  publicId: "11",
  name: "Plane wave in 3D",
  difficulty: 2,
  contentTypes: { audio: false, interactive: false, video: true },
  body: [principle01, task01, task02, task03],
};

export default lesson;
